import { render, staticRenderFns } from "./ClipIns.vue?vue&type=template&id=00fb2298&lang=pug&"
import script from "./ClipIns.vue?vue&type=script&lang=ts&"
export * from "./ClipIns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports